import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React from "react";

const NoEinzelcoachingInfoMessage = (): React.JSX.Element => (
  <Box
    sx={{
      backgroundColor: (theme) => theme.palette.info.main,
      color: (theme) => theme.palette.info.contrastText,
      gap: 2,
      my: 2,
      py: 3,
      px: 5,
      borderRadius: 2,
    }}
  >
    <Typography
      variant="h5"
      component="div"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        mb: 4,
      }}
    >
      <InfoOutlinedIcon />
      Du siehst keine buchbaren Einzelcoachingtermine?
    </Typography>

    <Typography variant="body1" component="div" sx={{ mb: 2 }}>
      Dies kann zwei Gründe haben.
    </Typography>

    <Typography variant="body1" component="div" sx={{ mb: 2 }}>
      1) Entweder du hast noch keine editierbare Datei (docx) bereitgestellt,
      oder du hast bereits drei Einzelcoachingtermine gebucht.
    </Typography>

    <Typography variant="body1" component="div">
      2) In beiden Fällen siehst du hier daher nur Speedcoachingtermine, denn
      unser Speedcoaching kannst du als „offene Stunde" ergänzend zu deinen
      gebuchten Einzelcoachingterminen so oft du magst zur Klärung erster,
      allgemeiner Fragen nutzen.
    </Typography>
  </Box>
);

export default NoEinzelcoachingInfoMessage;
